import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateChannel from "../../component/CreateChannel/ChannelUploader";

const VideoUploadForm = () => {
  return (
    <div className="flex items-center justify-center p-6">
      <CreateChannel />
      <ToastContainer position="top-right" autoClose={2500} hideProgressBar />
    </div>
  );
};

export default VideoUploadForm;
